<!-- 付款弹框金额渲染 -->
<template>
    <el-dialog title="支付信息" :visible.sync="centerDialogVisible" width="30%" center>
        <div v-loading="loading">
<!--            <div class="line">-->
<!--                <p>原订单金额：</p> <span>¥ {{ datas.oldOrderPrice }}</span>-->
<!--            </div>-->
            <div class="line">
                <p>原订单已退款金额：</p> <span>¥ {{ datas.oldOrderRefundPrice }}</span>
            </div>
            <div class="line">
                <p>当前订单金额：</p> <span>¥ {{ datas.orderPrice }}</span>
            </div>
<!--            <div class="line">-->
<!--                <p>需要支付的金额：</p> <span>¥ {{ datas.needPayOrderPrice }}</span>-->
<!--            </div>-->
            <div class="line">
                <p>原订单Id：</p> <span>{{ datas.parentId }}</span>
            </div>
            <div class="line">
                <p>原订单的支付方式：</p> <span>{{ mapPayMode[datas.payMode] }}</span>
            </div>
            <div class="line">
                <p>原订单是否已支付：</p> <span>{{ datas.isPay ? '已支付' : '未支付' }}</span>
            </div>
                <p style="color: red">点击确定之后原订单将会被取消</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="pay">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import PayApi from "@/components/Api/pay";
export default {
    components: {},
    data() {
        return {
            centerDialogVisible: false,
            loading: false,
            datas: {},
            mapPayMode: {
                0: '微信 ',
                1: '支付宝',
                2: '余额',
                3: '线下转账'
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        open(ids) {
            this.centerDialogVisible = true
            this.getRetrieveInfo(ids)
        },
        close() {
            this.centerDialogVisible = false
        },
        getRetrieveInfo(ids) {
            this.loading = true
            new PayApi("pay").retrieveInfo(ids).then(res => {
                console.log(res, '是看看打开打开');
                if (res.status === 200) {
                    this.datas = res.data
                    this.loading = false
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        pay() {
            new PayApi("pay").multipleRefunds(this.datas).then(res => {
                console.log(res, '是看看打开打开');
                if (res.status === 200) {
                    console.log(res, '时刻打开打开打开');
                    if (res.data) {
                        let obj = {
                            dataMap: {
                                totalPrice: 0,//实付金额
                                actualPrice: this.datas.orderPrice,//应付金额
                            },
                            payMoney: this.datas.orderPrice,//应付金额
                            orderMainId: this.datas.orderMainId,
                            orderChildrenIds: this.datas.orderChildrenIds
                        }
                        this.$emit('payOrder', obj)
                    }
                } else {
                    this.$message.error(res.statusText)
                }
            })
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.line {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    p {
        width: 150px;
        font-size: 15px;
    }

    span {
        font-size: 15px;
        color: #000;
        font-weight: bold;
    }
}
</style>